import { useState } from 'react';
import { toast } from 'react-toastify';
import { DaySequence, Job } from '@core/generated/gql-types';
import { useDaySequenceStore } from '@core/daySequence/useDaySequenceStore';
import TimesheetsToActionList from './TimesheetsToActionList';

interface TimesheetsToActionProps {
  job: Job;
  actionRequiredDaySequences: DaySequence[];
  fetchDaySequences: () => Promise<void>;
  loading: boolean;
}

const TimesheetsToAction = ({
  job,
  actionRequiredDaySequences,
  fetchDaySequences,
  loading,
}: TimesheetsToActionProps) => {
  const { approveDaySequences } = useDaySequenceStore();

  const [isApprovingTimesheets, setIsApprovingTimesheets] = useState(false);

  const onApproveDaySequences = async (daySequenceId: string) => {
    try {
      setIsApprovingTimesheets(true);
      const success = await approveDaySequences([daySequenceId]);
      if (success) {
        toast.success('Timesheet approved');
      } else {
        toast.error('Failed to approve timesheet');
      }
    } catch (error) {
      console.error('Error approving timesheet:', error);
      toast.error('Error while approving timesheet');
    } finally {
      await fetchDaySequences();
      setIsApprovingTimesheets(false);
    }
  };

  if (loading) {
    return (
      <div className="flex h-14 w-full items-center justify-between gap-2 rounded-md bg-white p-2">
        <div className="pl-3 text-sm text-gray-600">Loading...</div>
      </div>
    );
  }

  if (isApprovingTimesheets) {
    return (
      <div className="flex h-14 w-full items-center justify-between gap-2 rounded-md bg-white p-2">
        <div className="pl-3 text-sm text-gray-600">
          Approving timesheets...
        </div>
      </div>
    );
  }

  return (
    <TimesheetsToActionList
      jobId={job.id}
      actionRequiredDaySequences={actionRequiredDaySequences}
      onApprove={onApproveDaySequences}
    />
  );
};

export default TimesheetsToAction;
